import gql from 'graphql-tag';

export default gql`
  mutation RateCookbookItem($mealId: Int!, $rating: Float!, $labels: [String]) {
    cookbook {
      rating(mealId: $mealId) {
        rateItem(rating: $rating, labels: $labels) {
          __typename
          ... on BasicMutationSuccess {
            code
          }
        }
      }
    }
  }
`;
